import Solicitud from './index';

export const solicitudConfig = {
  key: `SOLICITUD`,
  path: `solicitud_apoyo`,
  element: <Solicitud />,
};
